import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'reactstrap';
import { Redirect, Link } from "react-router-dom";
import PeriodForm from '../PeriodForm/PeriodForm';
import PageTitle from '../../../components/PageTitle/PageTitle';

import { startCreatePeriod, createPeriod } from '../../../redux/modules/periods';

const PeriodCreate = () => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(startCreatePeriod());
    }, [dispatch])

    const submit = (values) => {
        console.log({ values });
        dispatch(createPeriod(values));
    }

    const { periodSuccessfullyCreated } = useSelector(state => state.periods);

    let title = <span>{t('periods.add')}</span>;

    const actions =
        <Button tag={Link} to="/periods" color="warning" size="sm">
            <i className="fa fa-arrow-left"></i>&nbsp;{ t('common.back')}
        </Button>

    return (
        <div className="PeriodCreate">
            <PageTitle icon="sun-o" title={ title } actions={ actions } />

            {periodSuccessfullyCreated &&
                <Redirect to="/periods"/>
            }

            <PeriodForm onSubmit={ submit } isCreation="true" />
        </div>
    );
}

export default PeriodCreate
